export default __webpack_public_path__ + "static/media/rkdatta_image_2.263762c1.jpeg";